import { render, staticRenderFns } from "./disabled-plate-dialog.vue?vue&type=template&id=4d02e8d2&scoped=true&lang=pug"
import script from "./disabled-plate-dialog.vue?vue&type=script&lang=ts"
export * from "./disabled-plate-dialog.vue?vue&type=script&lang=ts"
import style0 from "./disabled-plate-dialog.vue?vue&type=style&index=0&id=4d02e8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d02e8d2",
  null
  
)

export default component.exports